import { createFileRoute, redirect } from "@tanstack/react-router";

import { apiClient } from "../../../zodios/client";

/** Walmart's app-install entry point: starts the Marketplace OAuth session and hands off to Walmart's consent page. */
export const Route = createFileRoute("/_authenticated/walmart/install")({
  loader: async () => {
    const { redirect_url } = await apiClient.initWalmartOauth({
      queries: { success_path: "/user/walmartsummary", error_path: "/user/walmartsummary" },
    });
    // An external href is a full-page load, and router redirects replace, so Back from Walmart skips this URL.
    throw redirect({ href: redirect_url });
  },
});
